/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import {AppSettings, IEnvVars} from './app/config/app.settings';


if (environment.production) {
  enableProdMode();
}
AppSettings.API_URL = '';
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
